(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Oc-how-it-works-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.oc-how-works').forEach(section => {
    const slider = section.querySelector('.slider');
    const prevBtn = section.querySelector('.slider-button--prev');
    const nextBtn = section.querySelector('.slider-button--next');
    if (!slider) return;

    // --- Clone slides once for seamless looping ---
    const slides = Array.from(slider.children);
    if (!slider.dataset.loopPrepared) {
      slides.forEach(node => slider.appendChild(node.cloneNode(true)));
      slider.dataset.loopPrepared = 'true';
    }

    const gap = parseFloat(getComputedStyle(slider).gap || '0');
    const originalWidth =
      slides.reduce((w, el) => w + el.getBoundingClientRect().width, 0) +
      gap * (slides.length - 1);

    // --- Continuous scroll setup ---
    let rafId = null;
    let speed = Math.max(0.4, slider.clientWidth * 0.0015);
    let paused = false;

    function tick() {
      if (!paused) {
        slider.scrollLeft += speed;

        // Seamless wrap
        if (slider.scrollLeft >= originalWidth) {
          slider.scrollLeft -= originalWidth;
        } else if (slider.scrollLeft < 0) {
          slider.scrollLeft += originalWidth;
        }
      }
      rafId = requestAnimationFrame(tick);
    }

    function startAuto() {
      stopAuto();
      slider.classList.add('is-autoplaying');
      rafId = requestAnimationFrame(tick);
    }

    function stopAuto() {
      slider.classList.remove('is-autoplaying');
      if (rafId) cancelAnimationFrame(rafId);
      rafId = null;
    }

    // --- Button controls ---
    const jumpDistance = () => Math.max(200, slider.clientWidth * 0.3);

    nextBtn?.addEventListener('click', () => {
      paused = true;
      slider.scrollBy({ left: jumpDistance(), behavior: 'smooth' });

      setTimeout(() => {
        // Wrap seamlessly
        if (slider.scrollLeft >= originalWidth) {
          slider.scrollLeft -= originalWidth;
        }
        paused = false;
      }, 400);
    });

    prevBtn?.addEventListener('click', () => {
      paused = true;
      if (slider.scrollLeft <= 0) {
        slider.scrollLeft += originalWidth;
      }
      slider.scrollBy({ left: -jumpDistance(), behavior: 'smooth' });

      setTimeout(() => {
        paused = false;
      }, 400);
    });

    // --- Keep running forever ---
    window.addEventListener('resize', () => {
      speed = Math.max(0.4, slider.clientWidth * 0.0015);
    });

    startAuto();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oc-carousel-two"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.two-up .buttons').forEach(group => {
    const prev = group.querySelector('.prev');
    const next = group.querySelector('.next');
    const id = prev?.dataset.target || next?.dataset.target;
    const track = document.getElementById(id);
    if (!track) return;

    const step = () => Math.max(300, Math.round(track.clientWidth * 0.9));

    const scrollForward = () => {
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 5)
        track.scrollTo({ left: 0, behavior: 'smooth' });
      else
        track.scrollBy({ left: step(), behavior: 'smooth' });
    };

    const scrollBack = () => {
      if (track.scrollLeft <= 5)
        track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
      else
        track.scrollBy({ left: -step(), behavior: 'smooth' });
    };

    prev?.addEventListener('click', scrollBack);
    next?.addEventListener('click', scrollForward);

    let autoScroll = setInterval(() => {
      if (!track.matches(':hover')) scrollForward();
    }, 3000);

    track.addEventListener('mouseenter', () => clearInterval(autoScroll));
    track.addEventListener('mouseleave', () => {
      autoScroll = setInterval(() => {
        if (!track.matches(':hover')) scrollForward();
      }, 3000);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tx-studios-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.tx-studios-carousel').forEach(section => {
    const slider = section.querySelector('.slider');
    const prevBtn = section.querySelector('.slider-button--prev');
    const nextBtn = section.querySelector('.slider-button--next');
    if (!slider || !prevBtn || !nextBtn) return;

    // --- Helpers
    const getGap = () => {
      const cs = getComputedStyle(slider);
      return parseFloat(cs.columnGap || cs.gap || 0) || 0;
    };
    const getSlideWidth = () => {
      const first = slider.querySelector('.slider__slide');
      return first ? first.getBoundingClientRect().width + getGap() : 0;
    };

    let slideWidth = 0, totalWidth = 0, fullWidth = 0;
    const updateWidths = () => {
      slideWidth = getSlideWidth();
      totalWidth = slideWidth * originalSlides.length;
      fullWidth = slideWidth * slider.children.length;
    };

    const centerFirstSlide = () => {
      const firstSlide = slider.querySelector('.slider__slide');
      if (!firstSlide) return;
      const offset = (slider.clientWidth - firstSlide.offsetWidth) / 2;
      slider.scrollLeft = offset;
    };

    const originalSlides = Array.from(slider.children);

    // --- Initialize AFTER first paint (no blocking render)
    requestAnimationFrame(() => {
      // Clone slides for infinite loop
      originalSlides.forEach(slide => slider.appendChild(slide.cloneNode(true)));
      updateWidths();
      centerFirstSlide();
    });

    // --- Keep centered when layout changes
    const ro = new ResizeObserver(() => {
      updateWidths();
      centerFirstSlide();
    });
    ro.observe(slider);

    // --- Infinite loop checks
    const checkLoop = () => {
      if (slider.scrollLeft >= fullWidth - slider.clientWidth) {
        slider.scrollLeft -= totalWidth;
      } else if (slider.scrollLeft <= 0) {
        slider.scrollLeft += totalWidth;
      }
    };

    // --- Button navigation
    const jumpDistance = () => Math.max(200, slider.clientWidth * 0.3);
    nextBtn.addEventListener('click', () => {
      slider.scrollBy({ left: jumpDistance(), behavior: 'smooth' });
      setTimeout(checkLoop, 400);
    });
    prevBtn.addEventListener('click', () => {
      slider.scrollBy({ left: -jumpDistance(), behavior: 'smooth' });
      setTimeout(checkLoop, 400);
    });

    // --- Drag / touch scrolling
    let isDown = false, startX = 0, scrollStart = 0;
    slider.addEventListener('mousedown', e => {
      isDown = true;
      startX = e.pageX;
      scrollStart = slider.scrollLeft;
      slider.style.cursor = 'grabbing';
    });
    slider.addEventListener('mouseleave', () => { isDown = false; slider.style.cursor = 'grab'; });
    slider.addEventListener('mouseup', () => { isDown = false; slider.style.cursor = 'grab'; });
    slider.addEventListener('mousemove', e => {
      if (!isDown) return;
      const walk = (e.pageX - startX) * 1.5;
      slider.scrollLeft = scrollStart - walk;
      checkLoop();
    });

    // --- Touch
    let touchStartX = 0, touchScrollStart = 0;
    slider.addEventListener('touchstart', e => {
      touchStartX = e.touches[0].pageX;
      touchScrollStart = slider.scrollLeft;
    }, { passive: true });
    slider.addEventListener('touchmove', e => {
      const delta = e.touches[0].pageX - touchStartX;
      slider.scrollLeft = touchScrollStart - delta;
      checkLoop();
    }, { passive: true });

    slider.style.cursor = 'grab';
  });
});

  } catch(e) { console.error(e); }
})();
})();
